<template>
    
</template>

<script>
export default {
    created(){
        this.$store.dispatch("clearAuthData");
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue